import React, { useEffect, useState } from 'react';
import { Input, Button } from 'antd';
import { ASSET_TYPE } from '@src/components/scene/react-three-components/sceneAsset';

export function AddYoutube({ selectedModel, callBack, type, items }) {
  const prefix = 'https://youtube.com/';
  const [url, setURL] = useState(prefix);

  useEffect(() => {
    if (selectedModel?.props?.asset?.metadata?.url) {
      setURL(selectedModel.props.asset.metadata.url);
    } else {
      setURL(prefix);
    }
  }, [selectedModel, prefix]);

  const onChangeStreamURL = (e) => {
    let value = e.target.value;

    if (
      value.startsWith('http') ||
      value.includes('youtube.com') ||
      value.includes('youtu.be')
    ) {
      setURL(value);
    } else {
      setURL(prefix + value);
    }
  };

  const handleAddStream = () => {
    if (url && url !== prefix) {
      callBack({
        type: ASSET_TYPE.PRIMITIVE_TEXTURE.STREAM,
        name: items[0].name,
        metadata: {
          type: 'youtube',
          url: url,
        },
      });
    }
  };

  return (
    <>
      <p>YouTube URL</p>
      <Input
        onChange={onChangeStreamURL}
        value={url}
        placeholder='Enter YouTube URL'
      />

      <Button
        type='primary'
        style={{
          minHeight: 32,
          marginTop: 10,
        }}
        onClick={handleAddStream}
        disabled={!url || url === prefix}
      >
        Add YouTube Stream
      </Button>
    </>
  );
}
